import React, { useEffect } from "react";

const PageLayout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-ku-cream">
      {children}
    </div>
  );
};

export default PageLayout;
